<template>
    <div class="form-group"> 
        <label class="label required">{{ $t("weight") }}</label>
        <div class="row p-0">
            <div class="col-6 p-0">
                <app-input 
                   :placeholder="$t('Select unit')"
                    type="advance-search-select"
                    fetch-url="/units/serverside/selectable-name"
                    listValueField="code"
                    v-model="internalValue.size"
                    :loaded-per-time="5"
                    :required="true"
                    @input="updateValue"
                    :disabled="is_view"
                />
            </div>
            <div class="col-6 p-0">
                <app-input 
                    :placeholder="$t('weight')"
                    type="text"
                    v-model="displayValue"
                    @input="updateValue"
                    :disabled="is_view"
                    @blur="rawInput = ''"
                    :required="true"
                />
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'ProductSize',
    props: {
        value: {
            type: Object,
            default: () => ({
                size: { id : null, code : null, factor : null},
                quantity : 0,
            })
        },
        is_view : {
            type : Boolean,
            default: false,
        },
    },
    data() {
        return {
            isTypingDot: false,
            rawInput: '',
            internalValue: { ...this.value }
        };
    },
    watch: {
        // Si el padre cambia el objeto desde afuera, actualizamos nuestra copia
        value: {
            handler(newVal) {
                this.internalValue = JSON.parse(JSON.stringify(newVal));
            },
            deep: true
        }
    },
    computed : {
        displayValue: {
            get() {
                const val = this.internalValue.quantity;
                if (val === null || val === '') return this.rawInput || '';
                if (this.rawInput !== '') return this.rawInput;
                return new Intl.NumberFormat('en-US').format(val);
            },
            set(newValue) {
                const cleanValue = newValue.replace(/[^0-9.]/g, '');
                this.rawInput = cleanValue;
                if (cleanValue.endsWith('.')) {
                    this.isTypingDot = true;
                    return;
                }
                this.isTypingDot = false;
                const numericValue = cleanValue === '' ? null : parseFloat(cleanValue);
                if (!isNaN(numericValue) || cleanValue === '') {
                    this.internalValue.quantity = numericValue;
                    this.updateValue();
                }
            }
        }
    },
    methods: {
        updateValue() {
            this.$emit('input', { ...this.internalValue });
        }
    }
}
</script>

<style scoped>
    .label {
        font-weight: 600;
    }
    /* Quitamos paddings laterales de la fila interna para alinear con el label */
    .row {
        margin-left: 0;
        margin-right: 0;
    }
</style>